import request from "@/api";

export function listProject(data) {
    return request({
        url: '/api/project/getProjectList',
        method: 'get',
        params: data
    })
}
export function saveProject(data) {
    return request({
        url: '/api/project/saveProject',
        method: 'post',
        data: data
    })
}
export function getProjectInfo(data) {
    return request({
        url: '/api/project/getProjectInfo',
        method: 'get',
        params: data
    })
}

export function deleteProject(data) {
    return request({
        url: '/api/project/deleteProject',
        method: 'post',
        data: data
    })
}


export function listProjectConfig(data) {
    return request({
        url: '/api/project/config/getProjectConfigList',
        method: 'get',
        params: data
    })
}
export function saveProjectConfig(data) {
    return request({
        url: '/api/project/config/saveProjectConfig',
        method: 'post',
        data: data
    })
}
export function deleteProjectConfig(data) {
    return request({
        url: '/api/project/config/deleteProjectConfig',
        method: 'post',
        data: data
    })
}


export function listProjectUser(data) {
    return request({
        url: '/api/project/user/getProjectUserList',
        method: 'get',
        params: data
    })
}

export function saveProjectUser(data) {
    return request({
        url: '/api/project/user/saveProjectUser',
        method: 'post',
        data: data
    })
}

export function deleteProjectUser(data) {
    return request({
        url: '/api/project/user/deleteProjectUser',
        method: 'post',
        data: data
    })
}

//报表
export function getProjectStatReport(data) {
    return request({
        url: '/api/project/stat/getProjectStatReport',
        method: 'get',
        params: data
    })
}
export function exportProjectStat(data) {
    return request({
        url: '/api/report/exportProjectStat',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}